import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { Link, SocialNetworksAPI, TextAPI } from '@philips-emr/tws-components';
import { DismissStyle, ThemeTonalRange, ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnCatch, OnMount } from '@philips-emr/tws-core/lib/client';
import { MessageService, msg, ThemeService, ToastService } from '@philips-emr/tws-core/lib/services';
import { ModalProps, ModalService } from '@philips-emr/tws-core/lib/services/modal-service';
import { LoginAPI } from '@philips-emr/tws-foundation';

import { FragmentNames, LoginAliases } from '../../codegen';
import { Configuration } from '../../services/configuration';

@Controller({ fragment: FragmentNames.LOGIN })
export default class LoginController {

  @Inject(LoginAliases.TEXT_INFO)
  private textInfoAPI: TextAPI;

  @Inject(LoginAliases.SOCIAL_NETWORKS)
  private socialNetworksAPI: SocialNetworksAPI;

  @Inject(LoginAliases.LOGIN_COMPONENT)
  private loginAPI: LoginAPI;

  @OnMount(LoginAliases.LOGIN_COMPONENT)
  onLoginMount(): void {
    ThemeService.setContentTonalRange(Configuration.getTonalRange());

    void Configuration.getData().then(data => {

      data.dsUrlLogoHeaderLogin && this.loginAPI.setLogo(data.dsUrlLogoHeaderLogin);

      const info = `${data.dsAddress || ''}
      ${MessageService.msg('hi.telephone')}: ${data.nrContactPhone || ''}
      ${MessageService.msg('hi.email')}: ${data.dsEmailFooter || ''}`;
      this.textInfoAPI.setValue(info);

      data.dsLinkFacebook && this.socialNetworksAPI.setFacebook(data.dsLinkFacebook);
      data.dsLinkLinkedin && this.socialNetworksAPI.setLinkedin(data.dsLinkLinkedin);
      data.dsLinkYoutube && this.socialNetworksAPI.setYoutube(data.dsLinkYoutube);
      data.dsLinkInstagram && this.socialNetworksAPI.setInstagram(data.dsLinkInstagram);
      data.dsLinkTwitter && this.socialNetworksAPI.setTwitter(data.dsLinkTwitter);
    });

    setTimeout(() => this.cookiesToast(), 1000);
  }

  private cookiesToast(): void {

    ToastService.open({
      id: 'c-toast-notification__message--cookies',
      title: msg('hi.cookies-policy'),
      message: msg('hi.message-cookie-policies'),
      dismissible: true,
      dismissStyle: DismissStyle.BUTTON,
      showIcon: true,
      dismissExpression: msg('hi.confirmation-ok'),
      action: this.getMessageCookiePolicies(),
      level: ToastLevel.WARNING,
      highlight: true,
    });

  }

  @OnCatch(LoginAliases.LOGIN_COMPONENT)
  onCatchLogin(): void {
    this.showNotification();
  }

  showNotification(): void {
    this.loginAPI.setNotification({
      message: msg('hi.login-failed'),
      level: ToastLevel.WARNING,
      highlight: true,
    });
  }

  showCookiesModal(): void {
    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'cookie-policies',
      title: 'hi.cookies-policy',
      theme: ThemeTonalRange.ULTRA_LIGHT,
    };
    ModalService.openDefault(modalWithFragment);
  }

  private getMessageCookiePolicies(): ReactElement {
    return (
      <Link onClick={() => this.showCookiesModal()} value={msg('hi.cookies-policy')} />
    );
  }

}
